import * as React from 'react';
// import moment = require('moment');
import { FormErrorFeedback } from 'common/components/form/FormErrorFeedback';
import { Input, Label, FormGroup, InputProps } from 'reactstrap';
import { Field, FieldProps } from 'formik';
import { isFieldValid } from 'common/utils/form';
// import { has } from 'lodash';

export interface FormInputProps extends InputProps {
  label: React.ReactNode;
  name: string;
  id: string;
}

export class FormInput extends React.Component<FormInputProps> {
  render() {
    const { id, children, label, name, ...rest } = this.props;
    return (
      <Field name={name}>
        {({ field, form }: FieldProps) => {
          const invalid = !isFieldValid(form, name);

          return (
            <FormGroup>
              <Label for={id}>{label}</Label>
              <Input id={id} {...field} {...rest} invalid={invalid}>
                {children}
              </Input>
              <FormErrorFeedback field={name} form={form} />
            </FormGroup>
          );
        }}
      </Field>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/form/FormInput.tsx